export default {
  /**
   * @param targetUrl {string} url without query params to redirect to
   * @param targetLanguage {string} language we want to redirect to, format 'xx'
   *
   * @returns string
   */
  buildRedirectUrl(targetUrl, targetLanguage) {
    const currentUrl = window.location.href;
    const currentUrlHash = currentUrl.split(`#`)[1];

    if(currentUrl.indexOf(`?`) === -1) {
      return currentUrlHash ? `${targetUrl}?lang=${targetLanguage}#${currentUrlHash}` : `${targetUrl}?lang=${targetLanguage}`;
    }

    const currentUrlSplit = currentUrl.replace(`#${currentUrlHash}`, ``).split(`?`);
    const currentUrlParams = currentUrlSplit[1].split(`&`);
    let languageParamFound = false;

    /*
     * If separator appears at the beginning (or end) of the string, it still has the effect of splitting.
     * The result is an empty (i.e. zero length) string, which appears at the first (or last) position of the returned array.
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/split#Syntax
     *
     * remove the empty string from the array caused by split
     */
    if(currentUrlParams[0] === ``) {
      currentUrlSplit.splice(0, 1);
    }

    const modifiedUrlParams = currentUrlParams.map(param => {
      let returnParam = param;
      if(param.split(`=`)[0] === `lang`) {
        languageParamFound = true;
        returnParam = `lang=${targetLanguage}`;
      }
      return returnParam;
    });

    if(!languageParamFound) {
      modifiedUrlParams.push(`lang=${targetLanguage}`);
    }

    const modifiedUrl = [targetUrl, modifiedUrlParams.join(`&`)];
    modifiedUrl[1] = modifiedUrl[1].replace(/([?&])lang=de/g, ``);
    let url = modifiedUrl[1].length > 0 ? modifiedUrl.join(`?`) : modifiedUrl[0];
    if(currentUrlHash) {
      url += `#${currentUrlHash}`;
    }
    return url;
  },
};
